type YdymLogRow = {
  t: number;
  tag: string;
  data?: unknown;
};

const MAX = 300;
const rows: YdymLogRow[] = [];

function threadLabel() {
  return typeof document !== 'undefined' ? 'main' : 'worker';
}

export function ydymLog(tag: string, data?: unknown) {
  const row: YdymLogRow = { t: Date.now(), tag, data };
  rows.push(row);
  if (rows.length > MAX) rows.shift();
  try {
    // eslint-disable-next-line no-console
    console.log(`[YDYM][${threadLabel()}] ${tag}`, data === undefined ? '' : data);
  } catch {
    // ignore
  }
}

export function ydymLogError(tag: string, err: unknown) {
  const message = err instanceof Error ? err.message : String(err);
  ydymLog(`ERROR:${tag}`, { message });
}

export function ydymLogDump() {
  return rows.slice();
}

export function ydymInstallDebugHook() {
  if (typeof window === 'undefined') return;
  (window as any).__YDYM__ = {
    dump: ydymLogDump,
    print() {
      // eslint-disable-next-line no-console
      console.table(ydymLogDump().map((r) => ({
        time: new Date(r.t).toISOString().slice(11, 23),
        tag: r.tag,
        data: typeof r.data === 'string' ? r.data : JSON.stringify(r.data),
      })));
    },
  };
}
